module.exports = __webpack_public_path__ + "images/18b3202a7bdae0e07629a3dc3911c4a0.svg";